<woa-modal-page-layout>
    <woa-receipt [receiptXml]="sale().saleReceipt"></woa-receipt>
</woa-modal-page-layout>
